"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Text = _interopRequireDefault(require("../Text"));
var __jsx = _react.default.createElement;
var AboutUsEditConfig = {
  emptyLabel: 'Configure About Us Text',
  isEmpty: function isEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
  }
};
var AboutUs = function AboutUs(_ref) {
  var text = _ref.text,
    _ref$richText = _ref.richText,
    richText = _ref$richText === void 0 ? true : _ref$richText;
  if (!text) return null;
  return __jsx(_Text.default, {
    text: text,
    richText: richText
  });
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/aboutus')(AboutUs, AboutUsEditConfig);
exports.default = _default;